import React from "react";
import { Typography, Button, Box } from "@mui/material";
import { FormContainer } from "components/ui/FormField/FormFieldContainer";
import Page from "components/ui/Page/Page";

const EligibilityError = ({ onTryAgain }) => {
    return (
        <Page
            heading="Unfortunately, you are not eligible"
            subHeading="Based on your information, it looks like you are not eligible for the
                KardiaComplete program. If you believe this to be an error, please reach
                out to your company’s HR or Benefit team for more information. If you’d
                still like to monitor your heart, you can purchase a Kardia device at a
                discounted rate."
        >
            <FormContainer
                sx={{
                    textAlign: "center",
                    width: "65%",
                }}
            >
                <Button variant="outlined" onClick={onTryAgain}>
                    GET DISCOUNT
                </Button>
                <Button variant="outlined" onClick={onTryAgain}>
                    TRY AGAIN
                </Button>
            </FormContainer>
        </Page>
    );
};

export default EligibilityError;

export const EligibilityErrorUnderAge = ({ onTryAgain }) => {
    return (
        <Page
            heading="Unfortunately, you are not eligible"
            subHeading="Users under the age of 18 are not eligible for the KardiaComplete program. For more information, please feel free to reach out to our customer care team below."
        >
            <FormContainer
                sx={{
                    textAlign: "center",
                    width: "65%",
                }}
            >
                <Typography component={"div"} variant="body1" sx={{ mb: 2 }}>
                    <b>Customer Care</b>
                    <br />
                    Phone: +1 (855) 578-1085
                    <br />
                    Email: KardiaComplete@AliveCor.com
                </Typography>
                <Button variant="outlined" onClick={onTryAgain}>
                    TRY AGAIN
                </Button>
            </FormContainer>
        </Page>
    );
};
